import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function airlines(state=initialState.airlines, action) {
    switch (action.type) {
        case commonConstants.AIRLINES_SUCCESS:
            return Object.assign({}, state, action.airlines);
        default:
            return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/airline.reducer.js